import React from "react";
import { AnnouncementsProvider } from "./AnnoucementsContext";
import AnnouncementFilter from "./AnnouncementFilter";
import AnnouncementsList from "./AnnouncementsList";
import AnnouncementForm from "./AnnouncementForm";
import AnnouncementLog from "./AnnouncementLog";
import AnnouncementEvents from "./AnnouncementEvents";
import AnnouncementWebFilesAdmin from "./AnnouncementWebFilesAdmin";
import AnnouncementLinks from "./AnnouncementsLinks";
import AllAnnouncementsLogs from "./AllAnnouncementsLogs";

const AnnouncementsPage = () => {
  return (
    <AnnouncementsProvider>
      <AnnouncementFilter />
      <AnnouncementsList />
      <AnnouncementForm />
      <AnnouncementLog />
      <AnnouncementEvents />
      <AnnouncementWebFilesAdmin />
      <AnnouncementLinks />
      <AllAnnouncementsLogs />
    </AnnouncementsProvider>
  );
};

export default AnnouncementsPage;
